import { render, staticRenderFns } from "./repairTwos.vue?vue&type=template&id=a3a79474&scoped=true&"
import script from "./repairTwos.vue?vue&type=script&lang=js&"
export * from "./repairTwos.vue?vue&type=script&lang=js&"
import style0 from "./repairTwos.vue?vue&type=style&index=0&id=a3a79474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a79474",
  null
  
)

export default component.exports